module.exports = __webpack_public_path__ + "media/src/img/contacts-left-deco-27f85bead6a8b0d28d323f502655a79e.png";